import { Component, OnInit } from '@angular/core';
import { PublicService } from '../public.service';
import { FormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loading = false;

  phonenumberlogin = new FormControl('', [
    Validators.required,
    Validators.pattern("^09[0-9]{9}"),
  ]);

  constructor(public publicservice: PublicService, public router: Router) { 
    publicservice.logedIn = localStorage.getItem('logedInWaste')!;
    if (publicservice.logedIn == "true") {
      this.router.navigate(['home']);
    }
  }

  ngOnInit(): void {
  }
  FUck() {

  }
  login() {    
    // this.loading = true;
    if (this.phonenumberlogin.valid) {
      this.loading = true;
      this.publicservice.login().then(r => {
        this.loading = false;
        localStorage.setItem('phoneKarbar', this.publicservice.PhoneNumber);
        this.publicservice.PhoneNumberAgain = localStorage.getItem('phoneKarbar')!;
        if(  r.message == "successful") {
      
       
        this.router.navigate(['six-digit']);
        }else {
          alert(r.data);
        }
      });
    }
  }




}
